import React, { useContext, useEffect, useState } from 'react'
import filterIcon from '../../assets/icons/filters.svg';
import download from '../../assets/icons/download-icon.svg';
import { t } from 'i18next';
import useWindowSize from '../../customHooks/useWindowSize';
import { ButtonWhiteTwo } from '../Buttons/ButtonWhiteTwo';
import PermanenceFilterModal from './PermanenceFilterModal';
import PermanenceReportContext from '../../context/PermanenceReportContext/PermanenceReportContext';
import { havePermission, isoToDate, replaceExpecialCharacters } from '../../helpers/helpers';
import { ErrorAlert } from '../ErrorAlert/ErrorAlert';
import { Spinner } from 'reactstrap';
import PermanenceTotals from './PermanenceTotals/PermanenceTotals';
import CustomSelectDate from '../CustomSelectDate/CustomSelectDate';

const PermanenceFilterHeader = () => {

    const { windowWidth } = useWindowSize();

    const inputDateColor = windowWidth >= 576 ? 'bg-transparent border-0' : '';

    const [showModal, setShowModal] = useState(false);

    const [showDateModal, setShowDateModal] = useState(false);

    const { permanenceReportState, handleGetPermanenceReport, downloadPermanenceReport, downloadAlertHandler } = useContext(PermanenceReportContext);
    const { reportFilter, totalReport, reports, isFetchingTotalsReports, isDownloadingReport, downloadError, downloadMessage, totalPages } = permanenceReportState;
    const { date_from, date_to, search_text } = reportFilter;

    const dateValue = date_from === date_to ? t('TODAY') : (`${isoToDate(date_from.replaceAll('-', ''))}${windowWidth >= 576 ? '\n' : ' - '}${isoToDate(date_to.replaceAll('-', ''))}`)

    const noResults = reports.length === 0;

    const needToFilterMore = totalPages > process.env.REACT_APP_MAX_PAGES_DOWNLOAD_PERMANENCE_REPORT;

    const [searchText, setSearchText] = useState(search_text);

    const handleSearch = (e) => {
        if (e.key === 'Enter') {
            handleGetPermanenceReport({
                ...reportFilter,
                search_text: searchText,
                reg_from: 1,
            })
        }
    }

    const handleSetDatesInFilter = (date_from, date_to) => {
        handleGetPermanenceReport({
            ...reportFilter,
            search_text: searchText,
            date_from,
            date_to,
            reg_from: 1,
        })
    }

    useEffect(() => {
        setSearchText(search_text);
    }, [search_text])


    return (
        <>
            <PermanenceFilterModal
                showModal={showModal}
                setShowModal={setShowModal}
            />

            {showDateModal && (
                <CustomSelectDate
                    showModal={showDateModal}
                    setShowModal={setShowDateModal}
                    dateToInitialState={date_to}
                    dateFromInitialState={date_from}
                    onSubmit={handleSetDatesInFilter}
                />
            )}

            <ErrorAlert
                showModal={downloadError}
                setShowModal={() => downloadAlertHandler({ isDownloadingReport: false, downloadError: false, downloadMessage: false })}
                message={downloadMessage}
            />
            <div className='mb-3'>
                <div className="row row-cols-1 row-cols-sm-4 align-items-center gap-3 gap-sm-0">

                    <div className="col col-sm-4">
                        <div className='position-relative'>
                            <input
                                placeholder={t('SEARCH')}
                                type={"text"}
                                name={'searchAccess'}
                                className="form-control access-input"
                                autoComplete='off'
                                value={searchText}
                                onChange={(e) => setSearchText(replaceExpecialCharacters(e.target.value))}
                                onKeyPress={handleSearch}
                            />

                            <span
                                style={{ top: '15%', right: '10px', position: 'absolute' }}
                                type='button'
                                onClick={() => setShowModal(!showModal)}
                            >
                                <img src={filterIcon} alt="filters" />
                            </span>
                        </div>
                    </div>

                    <div className="col col-sm-3">
                        <div className='position-relative'>
                            <input
                                id='dateInReport'
                                value={dateValue}
                                type={"button"}
                                name={'searchAccess'}
                                style={{ fontSize: '14px' }}
                                className={`form-control datepicker-input text-start ${inputDateColor}`}
                                onClick={() => setShowDateModal(!showDateModal)}
                            />
                            <div
                                type='button'
                                className='position-absolute d-sm-none d-block'
                                style={{ top: '19%', right: '10px' }}
                                onClick={() => setShowDateModal(!showDateModal)}
                            >
                                <span style={{ fontSize: '12px' }} className='new-orange-color'>{t('CHANGE')}</span>
                            </div>
                        </div>
                    </div>

                    <div className="col col-sm-4 d-sm-block d-none">
                        <PermanenceTotals
                            totals={totalReport}
                            isFetching={isFetchingTotalsReports}
                        />
                    </div>

                    <div className="col col-sm-1 text-center ps-0 d-sm-block d-none">
                        {havePermission(7) && (
                            <ButtonWhiteTwo
                                onClick={downloadPermanenceReport}
                                withTooltip
                                idTargetTooltip={'export-permanence'}
                                placementTooltip={'top'}
                                className='btn-outline-black'
                                textTooltip={needToFilterMore ? t('FILTER_MORE_FOR_DOWNLOAD') : t('DOWNLOAD')}
                                disabled={noResults || isDownloadingReport || needToFilterMore}
                            >
                                {
                                    isDownloadingReport ?
                                        <Spinner />
                                        :
                                        <img src={download} alt="" />
                                }
                            </ButtonWhiteTwo>
                        )}
                    </div>

                </div>
            </div>
        </>
    )
}

export default PermanenceFilterHeader